module.exports = __webpack_public_path__ + "static/media/Banner Desktop-2.ca361a5d.png";